import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PseudoStates as Base } from '@cordata/buffet';

const PseudoStates = ({ mini, ...rest }) => {
  if (mini) {
    if (rest.status === 'loading') {
      return <span className="text-muted font-italic"><FontAwesomeIcon icon="spinner" spin fixedWidth className="mr-2" />Loading</span>;
    } else if (rest.status === 'error') {
      return <span className="text-danger"><FontAwesomeIcon icon="ban" fixedWidth className="mr-2" />Error</span>;
    } else if (rest.status === 'zero-state') {
      return <span className="text-tertiary"><FontAwesomeIcon icon="info-circle" fixedWidth className="mr-2" />Not Found</span>;
    }
  }

  return <Base {...rest} />;
};

PseudoStates.propTypes = {
  mini: PropTypes.bool,
};

PseudoStates.defaultProps = {
  mini: false,
};

export default PseudoStates;

